module.exports = __webpack_public_path__ + "img/实验室实验台.058b8c2a.jpg";